/**
 * Adzuki.TableCsvExport
 * Accepts the table element, the export file name and a button to push the download to
 */

(function TableCsvExport($, Adzuki)
{
	"use strict";
	
	var temp_column_delimiter = String.fromCharCode(11),
		temp_row_delimiter    = String.fromCharCode(0),
		column_delimiter = '","',
		row_delimiter = '"\r\n"';
	
	var tableCsvExport = function _csvExport(el, filename = 'export.csv', mappingFunction = null)
	{
		let $table_row,
			csv_data,
			csv_output;
		
		try {
			if (typeof el === 'string') {
				this.target_table = $(el);
			}
			
			if (typeof el === 'object') {
				this.target_table = el;
			}
			
			if (!this.target_table.length) {
				throw new Error('Cannot find ' + el);
			}
			
		} catch (e) {
			console.log('[Adzuki.MagnifierGlass]', el);
		}
		
		$table_row = this.target_table.find('tr:has(td, th)');
		
		if (typeof mappingFunction === 'function') {
			csv_data = '"' + $table_row.map(
				function handle(i, row) {
					let $row = $(row), $cols = $row.find('td, th');
					
					return $cols.map(function handle(j, col) {
						let $col = $(col);
						return mappingFunction($col);
						
					}).get().join(temp_column_delimiter);
				}
			).get().join(temp_row_delimiter).split(temp_row_delimiter).join(row_delimiter).split(temp_column_delimiter).join(column_delimiter) + '"';
		} else {
			csv_data = '"' + mapTableData($table_row);
		}
		
		csv_output = 'data:application/csv;charset=utf-8,' + encodeURIComponent(csv_data);
		
		if ($('#temp_export_button').length === 0) {
			$('body').append('<a type="button" id="temp_export_button"></a>');
		}
		
		$('#temp_export_button').attr({
			download: filename,
			href    : csv_output,
			target  : '_blank'
		});
		
		document.getElementById("temp_export_button").click();
	};
	
	/**
	 * Maps the table data for CSV export
	 * @param $table_row
	 * @returns {string}
	 */
	function mapTableData($table_row) {
		return $table_row.map(
			function handle(i, row) {
				let $row = $(row), $cols = $row.find('td, th');
				
				return $cols.map(function handle(j, col) {
					let $col = $(col), text = $col.text();
					text = text.trim();
					
					if (text === '') {
						let $child = $col.children();
						
						if ($child.is('input') && $child.attr('type') === 'checkbox') {
							return $child.is(':checked') ? 'Yes' : 'No';
						}
						
						if ($child.is('select')) {
							return '';
						}
						
						if ($child.is('img')) {
							return $child.attr('src');
						}
					}
					
					return text.replace('"', '""').replace('--', '');
				}).get().join(temp_column_delimiter);
				
			}).get().join(temp_row_delimiter).split(temp_row_delimiter).join(row_delimiter).split(temp_column_delimiter).join(column_delimiter) + '"';
	}

	Adzuki.TableCsvExport = tableCsvExport;
}(jQuery, window.Adzuki || {}));
